import React, { useEffect } from 'react';
import Header from './Header';
import './HomePage.css';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import { FaArrowUp, FaArrowDown, FaBook, FaInfoCircle, FaTools } from 'react-icons/fa';

const HomePage = () => {
  // Scroll to top function for the floating action button
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Add scroll animation effect
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementPosition = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        if (elementPosition < windowHeight - 100) {
          element.classList.add('animated');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    // Trigger once on load
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="home-container">
      <Header />
      <main className="home-content">
        <section className="hero-section">
          <h1>Welcome to ResoREP</h1>
          <p>Your ultimate hub for past exam papers and educational resources to boost your academic success.</p>
          
          <div className="scroll-indicator">
            <FaArrowDown />
          </div>
        </section>

        <h2 className="section-heading">Explore Our Resources</h2>
        
        <section className="blurb-section">
          <Link to="/subject?activeTab=papers" className="blurb-item past-papers-section animate-on-scroll" style={{ textDecoration: 'none', color: 'white' }}>
            <FaBook className="section-icon" />
            <h2>Past Papers</h2>
            <p>Access a comprehensive collection of exam papers with detailed marking schemes to help you prepare effectively.</p>
            <div className="cta-button">Explore Papers</div>
          </Link>
          
          <Link to="/about" className="blurb-item about-section animate-on-scroll" style={{ textDecoration: 'none', color: 'white' }}>
            <FaInfoCircle className="section-icon" />
            <h2>About Us</h2>
            <p>Discover our mission to democratize education by providing high-quality exam resources and guidance to students worldwide.</p>
            <div className="cta-button">Learn More</div>
          </Link>
          
          <Link to="/subject?activeTab=resources" className="blurb-item resources-section animate-on-scroll" style={{ textDecoration: 'none', color: 'white' }}>
            <FaTools className="section-icon" />
            <h2>Study Resources</h2>
            <p>Join our vibrant community and gain access to premium study materials, discussion forums, and collaborative learning tools.</p>
            <div className="cta-button">Get Resources</div>
          </Link>
        </section>

        {/* <section className="testimonials-section">
          <h2 className="section-heading">What Students Say</h2>
          <div className="testimonials-container">
            <div className="testimonial-card animate-on-scroll">
              <div className="testimonial-content">
                <p>"ResoREP has been instrumental in my exam preparation. The past papers are well-organized and the solutions are incredibly helpful."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar"></div>
                <div className="author-info">
                  <h4>I am a placeholder</h4>
                  <p>XYZ Student</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card animate-on-scroll">
              <div className="testimonial-content">
                <p>"The study resources available here are nonexistant. I've improved my grades significantly since I started using ResoREP."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar"></div>
                <div className="author-info">
                  <h4>Michael Chen</h4>
                  <p>Engineering Student</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="stats-section animate-on-scroll">
          <div className="stat-item">
            <h3>1000+</h3>
            <p>Past Papers</p>
          </div>
          <div className="stat-item">
            <h3>1K+</h3>
            <p>Active Users</p>
          </div>
          <div className="stat-item">
            <h3>20+</h3>
            <p>Subjects Covered</p>
          </div>
        </section>
      </main>
      
      <div className="floating-action-button" onClick={scrollToTop}>
        <FaArrowUp />
      </div>
      
      <Footer />
    </div>
  );
};

export default HomePage;